import { createContext, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import translations from "../translations";
import { LANGS, DEFAULT_LANG } from "../seo/siteConfig";

const LanguageContext = createContext();

export function detectBrowserLang() {
  const raw = (navigator.language || navigator.userLanguage || "nl").split("-")[0].toLowerCase();
  return LANGS.includes(raw) ? raw : DEFAULT_LANG;
}

function parsePath(pathname) {
  const match = pathname.match(/^\/(en|fr|de)(\/|$)/);
  if (match) {
    return { lang: match[1], basePath: pathname.slice(match[1].length + 1) || "/" };
  }
  return { lang: DEFAULT_LANG, basePath: pathname };
}

export function LanguageProvider({ children }) {
  const { pathname } = useLocation();
  const { lang, basePath } = useMemo(() => parsePath(pathname), [pathname]);
  const t = translations[lang] || translations[DEFAULT_LANG];

  function localizedPath(targetLang, path) {
    const p = path || basePath;
    if (targetLang === DEFAULT_LANG) return p === "/" ? "/" : p;
    return `/${targetLang}${p === "/" ? "" : p}`;
  }

  return (
    <LanguageContext.Provider value={{ language: lang, basePath, t, localizedPath }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}

export const languageNames = {
  nl: { name: "Nederlands", flag: "NL" },
  en: { name: "English", flag: "EN" },
  fr: { name: "Français", flag: "FR" },
  de: { name: "Deutsch", flag: "DE" },
};
